import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const INPUTSWITCH_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvanoToggleSwitchComponent),
  multi: true
};

@Component({
  selector: 'avano-toggle-switch',
  templateUrl: './avano-toggle-switch.component.html',
  styleUrls: ['./avano-toggle-switch.component.scss'],
  providers: [INPUTSWITCH_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoToggleSwitchComponent implements ControlValueAccessor {
  @Input() tabindex: number;

  @Input() inputId: string;

  @Input() name: string;

  @Input() disabled: boolean;

  @Input() readonly: boolean;

  @Input() trueValue: any = true;

  @Input() falseValue: any = false;

  @Input() ariaLabelledBy: string;
  @Input() labelLeft: string;
  @Input() labelRight: string;

  modelValue: any = false;


  // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-empty-function
  onModelChange: Function = () => {};

  // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};

  constructor(private cd: ChangeDetectorRef) {}

  onClick(event: Event, cb: HTMLInputElement) {
    if (!this.disabled && !this.readonly) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(event);
      cb.focus();
    }
  }

  onInputChange(event: Event) {
    if (!this.readonly) {
      const inputChecked = (<HTMLInputElement>event.target).checked;
      this.updateModel(event, inputChecked);
    }
  }

  toggle(event: Event) {
    this.updateModel(event, !this.checked());
  }

  updateModel(event: Event, value: boolean) {
    this.modelValue = value ? this.trueValue : this.falseValue;
    this.onModelChange(this.modelValue);
  }

  onBlur(event: Event) {
    this.onModelTouched();
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.cd.markForCheck();
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
    this.cd.markForCheck();
  }

  checked() {
    return this.modelValue === this.trueValue;
  }
}
